export const SHOP_SERVICES = {
  aeps: { en: "AEPS cash withdrawal", hi: "AEPS नकद निकासी" },
  dmt: { en: "Money transfer", hi: "मनी ट्रांसफर" },
  bbps: { en: "Bill payments", hi: "बिल भुगतान" },
  recharge: { en: "Recharge", hi: "रिचार्ज" },
  upi: { en: "UPI QR", hi: "UPI QR" },
  insurance: { en: "Insurance", hi: "बीमा" },
  travel: { en: "Travel booking", hi: "यात्रा बुकिंग" },
  pan: { en: "PAN services", hi: "PAN सेवाएं" },
  loans: { en: "Loans", hi: "लोन" },
};

export const serviceLabel = (key, lang = "en") => SHOP_SERVICES[key]?.[lang] ?? key;
